import languagesSpokenIcon from "components/Screens/Marketplace/Customer/assets/overview/languages-spoken.svg";
import englishProficiencyIcon from "components/Screens/Marketplace/Customer/assets/overview/english-proefficiency.svg";
import accentIcon from "components/Screens/Marketplace/Customer/assets/overview/accent.svg";
import energyIcon from "components/Screens/Marketplace/Customer/assets/overview/energy.svg";
import workExperienceIcon from "components/Screens/Marketplace/Customer/assets/overview/work-experience.svg";
import highestEducationIcon from "components/Screens/Marketplace/Customer/assets/overview/highest-education.svg";

import "components/Screens/Marketplace/Customer/ProfileSection/ProfileContent.scss";

interface OverviewItem {
  icon: string;
  label: string;
  value: string;
  iconBgColor?: string;
}

interface OverviewSectionProps {
  overviewItems: OverviewItem[];
}

function OverviewSection({ overviewItems }: OverviewSectionProps) {
  const getIconPath = (iconName: string) => {
    const iconMap: { [key: string]: string } = {
      "languages-spoken": languagesSpokenIcon,
      "english-proefficiency": englishProficiencyIcon,
      accent: accentIcon,
      energy: energyIcon,
      "work-experience": workExperienceIcon,
      "highest-education": highestEducationIcon,
    };

    const key = Object.keys(iconMap).find((k) => iconName.includes(k));
    return key ? iconMap[key] : iconName;
  };

  return (
    <div id="overview" className="profile-content__section">
      <div className="profile-content__title mb-075">Overview</div>
      <div className="overview-grid">
        {overviewItems.map((item) => (
          <div key={`${item.label}-${item.icon}`} className="overview-item">
            <div className="overview-icon">
              <img src={getIconPath(item.icon)} alt={item.label} />
            </div>
            <div className="overview-content">
              <div className="overview-label">{item.label}</div>
              <div className="overview-value">{item.value}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default OverviewSection;
